module.exports = __webpack_public_path__ + "static/img/quanvanminh.d29aefa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quanvanminh.png
// module id = BOie
// module chunks = 1